import { cn } from "../../util";
import { TEXT_CLASS_BY_LEVEL, type TextLevel } from "./constants";

export type Props = {
  as?: "p" | "div" | "span" | "label";
  children: React.ReactNode;
  className?: string;
  underline?: boolean;
  level?: TextLevel;
  italic?: boolean;
};

export default function Text({
  as = "p",
  children,
  className,
  underline,
  level = 1,
  italic,
}: Props) {
  const Tag = as;

  return (
    <Tag
      className={cn(
        "font-roboto font-normal text-neutral-black",
        underline ? "underline" : "",
        italic ? "italic" : "",
        TEXT_CLASS_BY_LEVEL[level],
        className,
      )}
    >
      {children}
    </Tag>
  );
}
